import gql from 'graphql-tag';

export const _GET_CONTACTS = gql`
	query getContacts($recipient: uuid!, $participant: uuid!) {
		total: risolto_contact_aggregate(where: { _and: { recipient: { _eq: $recipient }, participant: { _eq: $participant } } }) {
			aggregate {
				count
			}
		}
		contacts: risolto_contact(where: { _and: { recipient: { _eq: $recipient }, participant: { _eq: $participant } } }) {
			legal_entity
			participant
			first_name
			last_name
			full_name
			reference
			recipient
			channel_endpoints {
				endpoint_details
				deactivated_at
				deactivated_by
				channel
				endpoint
				reference
			}
		}
	}
`;

export const _GET_CONTACT = gql`
	query getContact($reference: uuid!, $participant: uuid) {
		contact: risolto_contact(where: { reference: { _eq: $reference }, participant: { _eq: $participant } }) {
			legal_entity
			participant
			first_name
			last_name
			reference
			recipient
			channel_endpoints {
				endpoint_details
				channel
				deactivated_at
				deactivated_by
				endpoint
				reference
			}
		}
	}
`;
